import { render, staticRenderFns } from "./SuccessTrainingForm.vue?vue&type=template&id=efc1fe1a&"
import script from "./SuccessTrainingForm.vue?vue&type=script&lang=js&"
export * from "./SuccessTrainingForm.vue?vue&type=script&lang=js&"
import style0 from "./SuccessTrainingForm.vue?vue&type=style&index=0&id=efc1fe1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports